// theme/components/accordion.js
export default {
    baseStyle: {
        border: 'none',
        button: {
            paddingLeft: 0,
            paddingRight: 0,
            _hover: {
                background: 'none'
            }
        },
        panel: {
            paddingTop: 0,
            paddingBottom: 0
        }
    },
    variants: {
        filter: {
            container: {
                paddingTop: '14px',
                paddingBottom: '14px'
            },
            button: {
                padding: 0,
                fontWeight: 500,
                border: 'none'
            },
            panel: {
                paddingTop: '14px',
                paddingRight: 0,
                paddingBottom: 0,
                paddingLeft: 0
            }
        },
        sidebar: {
            container: {
                padding: '12px 16px'
            },
            button: {
                border: 'none'
            }
        }
    }
}
